import { useEffect, useState } from 'react';
import { WSScanStatusData } from 'types';

export default function useSocket() {
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [wsStatusData, setWsStatusData] = useState<WSScanStatusData | null>(
    null
  );

  const connectWebSocket = ({
    sessionId,
    onConnect,
  }: {
    sessionId: string;
    onConnect?: () => void;
  }) => {
    if (socket) socket.close();

    const ws = new WebSocket(
      // `wss://zwjzk5n1z9.execute-api.us-west-2.amazonaws.com/dev?session_id=${sessionId}`
      `wss://m4c8ga7th2.execute-api.mx-central-1.amazonaws.com/dev-mx?session_id=${sessionId}`
    );
    setSocket(ws);
    onConnect?.();
  };

  useEffect(() => {
    if (socket) {
      socket.onopen = () => {
        console.info('Connected to WebSocket');
      };

      socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        setWsStatusData(message as WSScanStatusData);
      };

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      socket.onclose = () => {
        console.info('Disconnected from WebSocket');
      };
    }

    return () => {
      if (socket) socket.close();
    };
  }, [socket]);

  return { socket, wsStatusData, connectWebSocket, setWsStatusData };
}
